export default __webpack_public_path__ + "app/images/03f68fb4a5217d0c5ac68fa8294db757.svg";